var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.computedValue,
        callback: function ($$v) {
          _vm.computedValue = $$v
        },
        expression: "computedValue",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v("Download Options")]),
          _c(
            "v-card-text",
            [
              _c(
                "InputGeneric",
                {
                  staticClass: "mb-3",
                  attrs: { label: "Resources", "label-size": 3 },
                },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "hide-details": "",
                      items: _vm.resourcesItems,
                      dense: "",
                      multiple: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "prepend-item",
                        fn: function () {
                          return [
                            _c(
                              "v-list-item",
                              [
                                _c(
                                  "v-list-item-action",
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color:
                                            _vm.resources.length > 0
                                              ? "primary"
                                              : "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.icon(
                                                _vm.resourcesItems,
                                                _vm.resources
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(" Select All "),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("v-divider"),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.resources,
                      callback: function ($$v) {
                        _vm.resources = $$v
                      },
                      expression: "resources",
                    },
                  }),
                ],
                1
              ),
              _c(
                "InputGeneric",
                {
                  staticClass: "mb-3",
                  attrs: { label: "Nodes", "label-size": 3 },
                },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "hide-details": "",
                      items: _vm.nodesItems,
                      dense: "",
                      multiple: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "prepend-item",
                        fn: function () {
                          return [
                            _c(
                              "v-list-item",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-list-item-action",
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color:
                                            _vm.nodes.length > 0
                                              ? "primary"
                                              : "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.icon(
                                                _vm.nodesItems,
                                                _vm.nodes
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(" Select All "),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("v-divider"),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.nodes,
                      callback: function ($$v) {
                        _vm.nodes = $$v
                      },
                      expression: "nodes",
                    },
                  }),
                ],
                1
              ),
              _c(
                "InputGeneric",
                {
                  staticClass: "mb-3",
                  attrs: { label: "Years", "label-size": 3 },
                },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "hide-details": "",
                      items: _vm.yearsItems,
                      dense: "",
                      multiple: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "prepend-item",
                        fn: function () {
                          return [
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  mousedown: function ($event) {
                                    $event.preventDefault()
                                  },
                                  click: function ($event) {
                                    return _vm.toggle("years")
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-action",
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color:
                                            _vm.years.length > 0
                                              ? "primary"
                                              : "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.icon(
                                                _vm.yearsItems,
                                                _vm.years
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(" Select All "),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("v-divider"),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.years,
                      callback: function ($$v) {
                        _vm.years = $$v
                      },
                      expression: "years",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: {
                    small: "",
                    outlined: "",
                    color: "primary",
                    loading: _vm.downloadPending,
                  },
                  on: { click: _vm.downloadOutputs },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v("mdi-download"),
                  ]),
                  _vm._v(" download "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }